import {
  StaffVacationApprovalResponse,
  StaffVacationBalanceResponse,
  StaffVacationCancellationResponse,
  StaffVacationCreateRequest,
  StaffVacationDecisionRequest,
  StaffVacationDecisionResponse,
  StaffVacationEntitlementRequest,
  StaffVacationMovementResponse,
  StaffVacationRequestDetailResponse,
  StaffVacationRequestResponse,
  StaffVacationTypeResponse,
} from "lib-klab-sdks";
import {
  VacationApproval,
  VacationBalance,
  VacationCancellation,
  VacationCreateRequest,
  VacationDecision,
  VacationDecisionRequest,
  VacationEntitlementRequest,
  VacationMovement,
  VacationRequest,
  VacationRequestDetail,
  VacationType,
} from "../../../domain/models/employment/vacation.model";

export function mapVacationType(source: StaffVacationTypeResponse): VacationType {
  return {
    id: source.vacationTypeId,
    code: source.code,
    name: source.name,
    description: source.description,
    paid: source.paid,
    requiresApproval: source.requiresApproval,
    maxDays: source.maxDays,
    active: source.active,
  };
}

export function mapVacationBalance(
  source: StaffVacationBalanceResponse,
): VacationBalance {
  return {
    id: source.balanceId,
    employeeId: source.employeeId,
    vacationDays: Number(source.vacationDays),
    usedVacationDays: Number(source.usedVacationDays),
    bonusDays: Number(source.bonusDays),
    usedBonusDays: Number(source.usedBonusDays),
    accumulatedDays: Number(source.accumulatedDays),
    availableDays: Number(source.availableDays),
    lastBonusYear: source.lastBonusYear,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapVacationRequest(
  source: StaffVacationRequestResponse,
): VacationRequest {
  return {
    id: source.vacationRequestId,
    employeeId: source.employeeId,
    vacationTypeId: source.vacationTypeId,
    startDate: source.startDate,
    endDate: source.endDate,
    requestedDays: Number(source.requestedDays),
    reason: source.reason,
    status: source.status,
    attachmentUrl: source.attachmentUrl,
    requestedByUserId: source.requestedByUserId,
    cancelledByUserId: source.cancelledByUserId,
    cancelledAt: source.cancelledAt,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapVacationApproval(
  source: StaffVacationApprovalResponse,
): VacationApproval {
  return {
    id: source.approvalId,
    vacationRequestId: source.vacationRequestId,
    approvedByUserId: source.approvedByUserId,
    status: source.status,
    comment: source.comment,
    approvedAt: source.approvedAt,
  };
}

export function mapVacationMovement(
  source: StaffVacationMovementResponse,
): VacationMovement {
  return {
    id: source.movementId,
    employeeId: source.employeeId,
    vacationRequestId: source.vacationRequestId,
    type: source.type,
    days: Number(source.days),
    vacationDays: Number(source.vacationDays),
    bonusDays: Number(source.bonusDays),
    accumulatedDays: Number(source.accumulatedDays),
    balanceBefore: Number(source.balanceBefore),
    balanceAfter: Number(source.balanceAfter),
    description: source.description,
    performedByUserId: source.performedByUserId,
    createdAt: source.createdAt,
  };
}

export function mapVacationRequestDetail(
  source: StaffVacationRequestDetailResponse,
): VacationRequestDetail {
  return {
    request: mapVacationRequest(source.request),
    type: mapVacationType(source.type),
    approval: source.approval ? mapVacationApproval(source.approval) : null,
    movements: (source.movements ?? []).map(mapVacationMovement),
  };
}

export function mapVacationDecision(
  source: StaffVacationDecisionResponse,
): VacationDecision {
  return {
    request: mapVacationRequest(source.request),
    balance: source.balance ? mapVacationBalance(source.balance) : null,
    approval: mapVacationApproval(source.approval),
  };
}

export function mapVacationCancellation(
  source: StaffVacationCancellationResponse,
): VacationCancellation {
  return {
    request: mapVacationRequest(source.request),
    balance: source.balance ? mapVacationBalance(source.balance) : null,
    movement: source.movement ? mapVacationMovement(source.movement) : null,
  };
}

export function mapVacationCreateRequest(
  source: VacationCreateRequest,
): StaffVacationCreateRequest {
  return { ...source };
}

export function mapVacationDecisionRequest(
  source: VacationDecisionRequest,
): StaffVacationDecisionRequest {
  return { ...source };
}

export function mapVacationEntitlementRequest(
  source: VacationEntitlementRequest,
): StaffVacationEntitlementRequest {
  return { ...source };
}
